// Internationalisation dictionaries. EN + ES active; FR + DE scaffolded for future.
export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "fr", label: "Français", short: "FR", disabled: true },
  { code: "de", label: "Deutsch", short: "DE", disabled: true },
];

export const dictionaries = {
  en: {
    nav: {
      platform: "AI Governance OS",
      technology: "Technology",
      solutions: "Solutions",
      resources: "Resources",
      regulation: "Regulation",
      research: "Research",
      blog: "Blog",
      about: "About",
      documentation: "Documentation",
      trustCenter: "Trust Center",
      knowledge: "Knowledge Center",
      media: "Media Center",
      ecosystem: "Ecosystem",
    },
    cta: { access: "Access Platform", beta: "Request Private Beta", launch: "Launch Platform", contact: "Contact" },
    footer: { platforms: "Platforms", company: "Company", solutions: "Solutions", resources: "Resources", rights: "Sovereign AI Infrastructure. All rights reserved." },
  },
  es: {
    nav: {
      platform: "AI Governance OS",
      technology: "Tecnología",
      solutions: "Soluciones",
      resources: "Recursos",
      regulation: "Regulación",
      research: "Investigación",
      blog: "Blog",
      about: "Nosotros",
      documentation: "Documentación",
      trustCenter: "Centro de Confianza",
      knowledge: "Centro de Conocimiento",
      media: "Centro de Prensa",
      ecosystem: "Ecosistema",
    },
    cta: { access: "Acceder a la Plataforma", beta: "Solicitar Beta Privada", launch: "Abrir Plataforma", contact: "Contacto" },
    footer: { platforms: "Plataformas", company: "Compañía", solutions: "Soluciones", resources: "Recursos", rights: "Infraestructura de IA Soberana. Todos los derechos reservados." },
  },
};
